import { constructClientPath } from '../../../../../../packages/toolkit/src/utils/functions/construct-path'
import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { User } from '../../../lib/types/models/users/user'

const userRoleDefaultPageMapping = ({
  enrollmentId
}: {
  enrollmentId?: number
}): Record<RoleEnum, string> => {
  return {
    ADMIN: Paths.ENROLLMENT_LIST_PAGE,
    PCR: Paths.PCR_PERSONAL_SPACE_KANBAN,
    STAFF: Paths.STAFF_PERSONAL_SPACE_INFORMATION,
    Ol: Paths.OL_PERSONAL_SPACE_CENTER_LIST_PAGE,
    ACCOUNTANT: Paths.ACCOUNTANT_PERSONAL_SPACE_AFFECTED_STAFFS_SALARIES_LIST_PAGE,
    SYSTEM_ADMIN: Paths.SYSTEM_ADMIN_USERS_LIST_PAGE,
    CLIENT: enrollmentId
      ? constructClientPath(Paths.CLIENT_PERSONAL_SPACE_HOME, enrollmentId)
      : Paths.CLIENT_PERSONAL_SPACE_REDIRECTION
  }
}

export const getUserDefaultRedirectionPath = (user: User, enrollmentId?: number): string => {
  const role = user.role
  const mapping = userRoleDefaultPageMapping({ enrollmentId })
  return mapping[role]
}

export type UserType = 'client' | 'admin' | 'staff' | 'ol'

export const pathnameToUserType: Record<string, UserType> = {
  [Paths.AUTH_STAFF_LOGIN_PAGE]: 'staff',
  [Paths.AUTH_OL_LOGIN_PAGE]: 'ol',
  [Paths.AUTH_PCR_LOGIN_PAGE]: 'admin',
  [Paths.AUTH_CLIENT_LOGIN_PAGE]: 'client'
}

/**
 * Accepts only a same-origin relative path, so a tokenized magic link can never be used to
 * bounce a freshly authenticated user to an external site.
 */
export const getSafeRedirectPath = (raw: string | null): string | null => {
  if (!raw) return null
  if (raw.startsWith('//')) return null
  if (raw.includes('://')) return null
  if (raw.includes('\\')) return null
  return raw.startsWith('/') ? raw : `/${raw}`
}

// Each personal space has its own login page; anything else belongs to the admin one.
const spaceLoginMapping: Record<string, string> = {
  '/client-personal-space': Paths.AUTH_CLIENT_LOGIN_PAGE,
  '/staff-personal-space': Paths.AUTH_STAFF_LOGIN_PAGE,
  '/ol-personal-space': Paths.AUTH_OL_LOGIN_PAGE,
  '/pcr-personal-space': Paths.AUTH_PCR_LOGIN_PAGE
}

export const getLoginPage = (pathname?: string | null) => {
  if (!pathname) return Paths.AUTH_LOGIN_PAGE
  const spacePrefix = Object.keys(spaceLoginMapping).find((prefix) => pathname.startsWith(prefix))
  return spacePrefix ? spaceLoginMapping[spacePrefix] : Paths.AUTH_LOGIN_PAGE
}
